<div class="inner-container">
  <div class="header" *ngIf="showHeader">
    <img
      class="back-button"
      (click)="back()"
      src="assets/icons/news/back-arrow.svg"
      alt="back button"
    />
    <div class="title-container">
      <h3>Ingresá dinero</h3>
      <p>Realizá una transferencia a nuestra plataforma</p>
    </div>
  </div>
  <div class="limits">
    <img src="/assets/icons/deposit.svg" alt="" />
    <h3 class="limits-description">
      Podés depositar hasta: <span>{{ monthLimit | number : '0.2-2' }} AR$</span>
    </h3>
    <a [routerLink]="['profile', 'documentation']" (click)="close()">Ver más</a>
  </div>
  <div class="options-container">
    <p class="company">Sixalime SAS.</p>

    <b class="option-title">CBU/CVU</b>
    <div class="option">
      <div class="left">
        <p class="number">{{ getCbuByType() }}</p>
      </div>
      <div class="right">
        <img
          src="assets/icons/news/copy_violet.svg"
          alt="copy"
          (click)="copyCBUToClipboard('CBU')"
        />
      </div>
    </div>

    <b class="option-title" *ngIf="getAliasByType()">ALIAS</b>
    <div class="option" *ngIf="getAliasByType()">
      <div class="left">
        <p class="number">{{ getAliasByType() }}</p>
      </div>
      <div class="right">
        <img
          src="assets/icons/news/copy_violet.svg"
          alt="copy"
          (click)="copyCBUToClipboard('ALIAS')"
        />
      </div>
    </div>

    <app-reminder-message
      class="alert"
      *ngIf="isDepositDisabled"
      [message]="
        'Los depósitos en ' +
        (this.type === 1 ? 'pesos' : 'dólares') +
        ' se encuentran temporalmente deshabilitados. Por favor, intentá mas tarde.'
      "
      type="warning"
    ></app-reminder-message>

    <app-reminder-message
      class="alert"
      *ngIf="showWarningMessage"
      message="Recordá transferir desde una cuenta a tu nombre y no desde cuentas de terceros."
      type="warning"
    ></app-reminder-message>

    <app-reminder-message
      class="alert"
      *ngIf="showReminderMessage"
      message="Por lo general, las acreditaciones son prácticamente instantáneas durante el día. A partir de las 18hs pueden demorar hasta 30 minutos."
      type="reminder"
    ></app-reminder-message>

    <button class="td-btn primary" *ngIf="showHeader" (click)="close()">Aceptar</button>
  </div>
</div>
